import { RunState } from "types/generated";

const CPU_PROFILE_ONGOING_MESSAGE =
  "The CPU profile will be available for download once this phase completes.";

export const hasCpuProfile = (state: RunState) => {
  switch (state) {
    case RunState.Initializing:
    case RunState.Planning:
    case RunState.Applying:
    case RunState.Destroying:
      return true;
    case RunState.Canceled:
    case RunState.Confirmed:
    case RunState.Discarded:
    case RunState.Failed:
    case RunState.Finished:
    case RunState.Pending: // eslint-disable-line @typescript-eslint/no-deprecated -- listed only for exhaustiveness
    case RunState.PendingReview:
    case RunState.Performing:
    case RunState.Preparing:
    case RunState.PreparingApply:
    case RunState.PreparingReplan:
    case RunState.Queued:
    case RunState.Ready:
    case RunState.ReplanRequested:
    case RunState.Skipped:
    case RunState.Stopped:
    case RunState.Unconfirmed:
    case RunState.Unknown:
      return false;
  }
};

export const getCpuProfileUnavailableMessage = (profile?: { ongoing: boolean } | null) => {
  if (profile?.ongoing) {
    return CPU_PROFILE_ONGOING_MESSAGE;
  }

  return "The CPU profile is not available. It has expired, or this phase did not produce one.";
};

export const getCpuProfileUnavailableReason = (ongoing: boolean) =>
  ongoing ? CPU_PROFILE_ONGOING_MESSAGE : undefined;

export const getCpuProfileFileName = (runId: string, phase: RunState) =>
  `run-${runId}-${phase}.pprof`;
